import { RoomReducer } from '../../dataStore/reducers/room/defaultState'
import { Role } from '../../dataStore/constants/roles'
import uniq from 'lodash/uniq'

export default function (participantLookup: RoomReducer['participantLookup'], ...roles: Role[]) {

  return uniq(
    Object.entries(participantLookup)
      .filter(([ , { role } ]) => roles.includes(role))
      .map(([ , { BTID } ]) => BTID)
  )

}
